import { READ_SUMMARY_FAILURE, READ_SUMMARY_SUCCESS } from '../actions/summary'

const defect = (state = {}, action) => {
  switch (action.type) {
    case READ_SUMMARY_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case READ_SUMMARY_FAILURE:
    default:
      return state
  }
}

export default defect


// WEBPACK FOOTER //
// ./src/reducers/summary.js